import { OrganizationLevelType } from '@/shared/organizations/enums';

export const organizationColumns = (allOrganizations: any) => [
  {
    title: 'Областной уровень',
    dataIndex: 'region',
    width: 450,
    render: (_value: any, record: any) =>
      record?.level === OrganizationLevelType.REGION ? record?.name : '',
  },
  {
    title: 'Районный уровень',
    dataIndex: 'district',
    width: 450,
    render: (_value: any, record: any) =>
      record?.level === OrganizationLevelType.DISTRICT ? record?.name : '',
  },
  {
    title: 'Организация',
    dataIndex: 'org',
    width: 450,
    render: (_value: any, record: any) =>
      record?.level === OrganizationLevelType.ORGANIZATION ? record?.name : '',
  },
];
